import React from "react";

//todo
//this is the place holder for tags page table
//get this content from https://code.amazon.com/reviews/CR-110679996/revisions/1#/diff and build on top of this
export const TagsPageTable = () => {
  return <div>TagsPageTable</div>;
};
